import { motion } from "framer-motion";
import styled from "@emotion/styled";
import { Theme } from "../../styles/theme";
import { GlobalStore } from "../../store/global/GlobalStore";
import { useCallback } from "react";

interface ProgressBarProps {
  step: number;
  hasError?: boolean;
}

const PROGRESS_BAR_STEPS = 4;
export const ProgressBar: React.FC<ProgressBarProps> = ({ step, hasError }) => {
  const theme = GlobalStore.useState(s => s.theme);

  const content = useCallback(
    (isPassed: boolean, isCurrent: boolean) => {
      const barVariants = {
        hidden: { width: "0%" },
        visible: { width: "100%" },
      };

      if (isPassed) {
        return <StyledProgressBar hasError={hasError} style={{ width: "100%" }} theme={theme} />;
      }
      if (isCurrent) {
        return (
          <StyledProgressBar
            initial="hidden"
            animate="visible"
            variants={barVariants}
            transition={{ duration: 0.1 }}
            theme={theme}
          />
        );
      }
      return null;
    },
    [theme, hasError]
  );

  return (
    <div className="d-flex progress-wrapper">
      {Array.from({ length: PROGRESS_BAR_STEPS }).map((_, index) => {
        const currentStep = index + 1;
        const isCurrent = step === currentStep;
        const isPassed = step > currentStep;

        return (
          <div className={`progress step-${currentStep} col mx-1px`} key={currentStep}>
            {content(isPassed, isCurrent)}
          </div>
        );
      })}
    </div>
  );
};

const StyledProgressBar = styled(motion.div)<{ theme: Theme; hasError?: boolean }>`
  background: ${props =>
    props.hasError
      ? props.theme["Colour ramps"].Coral["1000"]
      : props.theme["Colour ramps"].Aqua["600"]};
  transition: width 1s linear !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
`;
